// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1jwGk","title":"BackImages_title__1CZ5g","images":"BackImages_images__1R2VD"};